<template>
  <div>
    <testcomponents />
  </div>
</template>

<script>
import testcomponents from "@/components/testcomponents.vue";
export default {
  components: { testcomponents },
};
</script>
